export default function dynamicTargetkeys(key, value) {

  //uri key
  webmd.ads2.setPageTarget("uri", window.location.pathname);

  //ecd key
  if (ibAds.getECD()) {
    webmd.ads2.setPageTarget("ecd", ibAds.getECD());
  }
  // Pass eed when available in page seg vars or else '0'
  webmd.ads2.setPageTarget("eed", PageMetadata?.pageSegVars?.eed == true ? 'true' : '0');

  //usps and usoo keys
  let usprivacycookie = ibAds.getCookie("usprivacy");
  if (usprivacycookie) {
    try {
      let usoo = usprivacycookie.charAt(2);
      webmd.ads2.setPageTarget("usps", usprivacycookie);
      webmd.ads2.setPageTarget("usoo", usoo);
    } catch (e) {
      console.error(
        "Something went wrong while fetching the usprivacy cookie",
        e
      );
    }
  }

  //dmp key
  var aam = ibAds.getCookie("aam") == null
    ? ibAds.getCookie("AAM")
    : ibAds.getCookie("aam");
  aam = decodeURIComponent(aam);
  var aamSt = "";

  if (key == "dmp" && aam == null) {
    // first page load aam not available if dmp available add it to cust_params
    var uniqueDMPValues = value.filter(ibAds.uniqueArray);
    webmd.ads2.setPageTarget(key, uniqueDMPValues);
  }
  if (aam != null) {
    //if aam cookie available
    aam = aam.toLowerCase();
    aamSt = aam.split("aam=").filter((e) => e != "");
    if (key == "dmp") {
      // already existing dmp key value add the cookie at the end.
      var allDMPkeys = value + "," + aamSt;
      var allDMPkeysArray = allDMPkeys.split(",");
      var uniqueAAMDMP = allDMPkeysArray.filter(ibAds.uniqueArray);
      webmd.ads2.setPageTarget("dmp", uniqueAAMDMP);
      findDmp = 1;
    }
    if (findDmp == 0) {
      //if dmp key not available then add dmp key with aam cookie value.
      var uniqueAAM = aamSt.filter(ibAds.uniqueArray);
      webmd.ads2.setPageTarget("dmp", uniqueAAM);
    }
  }

  //aamid key
  var auu = 0;
  ibAds.getCookie("aam_uuid") == null
    ? null
    : (auu = ibAds.getCookie("aam_uuid"));
  webmd.ads2.setPageTarget("aamid", auu);

  //medtab key
  if (isEmed || isDD) {
    var hash = location.hash;
    var pageNumber = hash.split("#")[1];
    var number = pageNumber != undefined ? pageNumber : 0;
    webmd.ads2.setPageTarget("medtab", number);
  }

  //urlkw key
  const urlPath = window.location.pathname;
  const urlkw = [];
  const lettersRegex = /^[a-zA-Z]+$/;
  const stopwords = [
    "a",
    "an",
    "the",
    "and",
    "for",
    "but",
    "so",
    "or",
    "yet",
    "nor",
    "although",
    "before",
    "after",
    "because",
    "if",
    "how",
    "once",
    "so",
    "since",
    "that",
    "unless",
    "until",
    "when",
    "either",
    "not",
    "only",
    "neither",
    "whether",
    "aboard",
    "about",
    "above",
    "across",
    "after",
    "against",
    "along",
    "amid",
    "among",
    "around",
    "as",
    "at",
    "before",
    "behind",
    "below",
    "beneath",
    "beside",
    "besides",
    "between",
    "beyond",
    "but",
    "by",
    "despite",
    "down",
    "during",
    "except",
    "for",
    "from",
    "in",
    "inside",
    "into",
    "like",
    "near",
    "of",
    "off",
    "on",
    "onto",
    "outside",
    "over",
    "past",
    "per",
    "plus",
    "save",
    "since",
    "than",
    "through",
    "to",
    "toward",
    "towards",
    "under",
    "underneath",
    "unlike",
    "until",
    "up",
    "upon",
    "versus",
    "via",
    "with",
    "within",
    "without",
  ];
  const exludeList = [ "viewarticle", "s", "article" ];
  const urlKeys = urlPath
    .split("/")
    .filter(Boolean)
    .filter((ele) => !exludeList.includes(ele.toLowerCase()));
  urlKeys.forEach((key) => {
    if (key.indexOf("-") > -1) {
      urlkw.push(
        ...key
          .split("-")
          .filter(
            (ele) =>
              lettersRegex.test(ele) && !stopwords.includes(ele.toLowerCase())
          )
      );
    } else {
      if (lettersRegex.test(key) && !stopwords.includes(key.toLowerCase())) {
        urlkw.push(key);
      }
    }
  });
  webmd.ads2.setPageTarget("urlkw", urlkw);

  // HUID key
  const huid = window.PageMetadata && PageMetadata.userSegVars && PageMetadata.userSegVars.huid
    ? String(PageMetadata.userSegVars.huid).trim()
    : "0";
  webmd.ads2.setPageTarget('huid', huid !== '' ? huid : "0");


  //dpt key
  if (
    _isODP &&
    PageMetadata.pageSegVar &&
    PageMetadata.pageSegVars.pc == "indexpage"
  ) {
    let urlObj = ibAds.getUrlVars();
    let mainType = Object.keys(urlObj)[0];

    const keyArray = [ "ctype", "type" ];
    if (keyArray.indexOf(mainType) !== -1) {
      let mainTypeValue = decodeURI(urlObj[Object.keys(urlObj)[0]]);
      let subTypeValue = decodeURI(urlObj[Object.keys(urlObj)[1]]);
      webmd.ads2.setPageTarget("dpt", mainTypeValue + "," + subTypeValue);
    } else {
      webmd.ads2.setPageTarget("dpt", 0);
    }
  }

  //tug key
  if (typeof networkGate !== "undefined" && networkGate !== null) {
    let tug =
      typeof networkGate.bundleId !== "undefined" && networkGate.bundleId != ""
        ? networkGate.bundleId.toString()
        : "0";
    webmd.ads2.setPageTarget("tug", tug);
  }

  // fpt key
  if (ibAds.getCookie("fpt") == null) {
    if (typeof isFPFEligible == "undefined") {
      document.cookie = "fpt = 0; domain = .medscape.com; path = /";
      document.cookie = "fpt = 0; domain = .medscape.org; path = /";
    } else if (isFPFEligible == false) {
      document.cookie = "fpt = ff; domain = .medscape.com, path = /";
      document.cookie = "fpt = ff; domain = .medscape.org, path = /";
    } else if (isFPFEligible == true) {
      document.cookie = "fpt = ff; domain = .medscape.com, path = /";
      document.cookie = "fpt = ff; domain = .medscape.org, path = /";
    } else {
      document.cookie = "fpt = 0; domain = .medscape.com; path = /";
      document.cookie = "fpt = 0; domain = .medscape.org; path = /";
    }
  }
  var fpt = ibAds.getCookie("fpt");
  webmd.ads2.setPageTarget("fpt", fpt);

  // pg key
  setTimeout(()=>{
    webmd.ads2.setPageTarget("pg", ibAds.getPageNumber());
  }, 100); //due to slight delay in url update on aspen added timeout to get updated value

  // oid key
  if (typeof visitor === "undefined") {
    document.addEventListener("visitorIdSet", function() {
      webmd.ads2.setPageTarget("oid", visitor.getMarketingCloudVisitorID());
    });
  } else {
    webmd.ads2.setPageTarget("oid", visitor.getMarketingCloudVisitorID());
  }

  //iaf key
  if (sessionStorage.getItem("url") === null) {
    sessionStorage.setItem("url", window.location.href);
  }
  if (window.location.href == sessionStorage.getItem("url")) {
    webmd.ads2.setPageTarget("iaf", "1");
    sessionStorage.setItem("clicked", "1");
  }
  if (
    sessionStorage.getItem("url") !== null &&
    window.location.href.indexOf("#") != "-1" &&
    sessionStorage
      .getItem("url")
      .indexOf(window.location.href.split("#")[0]) !== -1
  ) {
    webmd.ads2.setPageTarget("iaf", "1");
  } else if (
    sessionStorage.getItem("url") !== null &&
    window.location.href.indexOf("_") != "-1" &&
    sessionStorage
      .getItem("url")
      .indexOf(window.location.href.split("_")[0]) !== -1
  ) {
    webmd.ads2.setPageTarget("iaf", "1");
  } else if (
    sessionStorage.getItem("url") !== null &&
    sessionStorage.getItem("clicked") == "1" &&
    window.location.href != sessionStorage.getItem("url")
  ) {
    webmd.ads2.setPageTarget("iaf", "0");
  }

}

